import React from "react";
import { useDispatch } from "react-redux";
import { Card, CardBody, Col, Label, Row, Table } from "reactstrap";
import { updateLeadBusinessEntity } from "store/leads/lead_business_entity_actions";
import LeadEditDropdown from "./LeadEditDropdown";
import { getPrimaryTextClass } from "helpers/sf_utils";

const LeadBusinessEntityGroupHealth = ({ business_entities }) => {
    const dispatch = useDispatch();

    // Get the first (and only) business entity
    const business_entity = business_entities?.[0];

    return (
        <Card>
            <CardBody className="pt-0">
                <Row>
                    <div className="px-0">
                        <Table className="mb-0 text-black">
                            <tbody>
                                <tr>
                                    <td style={{ width: '50%' }}>
                                        <Col className="d-flex align-items-end pt-1 my-2">
                                            <i className={`me-2 bx fs-24 bx-buildings ${getPrimaryTextClass()}`} />
                                            <div className="me-2 fs-15 font-weight-semibold">
                                                Business Entity
                                            </div>
                                        </Col>
                                    </td>
                                    <td style={{ width: '50%' }}></td>
                                </tr>
                                <tr>
                                    <td style={{ width: '50%' }}>
                                        <div className="d-flex align-items-center">
                                            <Label className="mb-0 font-weight-semibold me-2">
                                                Business Name
                                            </Label>
                                            <div className="d-flex align-items-center">
                                                <LeadEditDropdown
                                                    title='Business Name'
                                                    field={business_entity?.business_name || '--'}
                                                    onSave={(value) => {
                                                        let data = {
                                                            id: business_entity?.id,
                                                            business_name: value
                                                        }
                                                        dispatch(updateLeadBusinessEntity({ lead_business_entity: data }))
                                                    }}
                                                    onCancel={() => { }}
                                                />
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ width: '50%' }}>
                                        <div className="d-flex align-items-center">
                                            <Label className="mb-0 font-weight-semibold me-2">
                                                Number of Employees
                                            </Label>
                                            <div className="d-flex align-items-center">
                                                <LeadEditDropdown
                                                    title='Number of Employees'
                                                    field={business_entity?.num_employees}
                                                    onSave={(value) => {
                                                        let data = {
                                                            id: business_entity?.id,
                                                            num_employees: value
                                                        }
                                                        dispatch(updateLeadBusinessEntity({ lead_business_entity: data }))
                                                    }}
                                                    onCancel={() => { }}
                                                />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </Row>
            </CardBody>
        </Card>
    )
}

export default LeadBusinessEntityGroupHealth 